export const SIZE_FONT = {
  small: "0.9rem",
  medium: "1rem",
  large: "1.1rem",
} as const;

/** Shared outer height for single-line buttons, inputs, and dropdowns. */
export const CONTROL_HEIGHT = {
  small: "28px",
  medium: "36px",
  large: "44px",
} as const;
